import { Link } from "react-router-dom";
import type { Story } from "@/utils/catalog";

interface StoryCardProps {
  story: Story;
}

export default function StoryCard({ story }: StoryCardProps) {
  return (
    <Link
      to={`/detail/story/${story.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition hover:border-primary-300"
    >
      <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
        <img
          src={story.cover}
          alt={`${story.title}剧照`}
          title={`${story.title} 剧情介绍`}
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-0.5 text-[11px] text-primary-700">
          {story.season}
        </span>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 text-[11px] text-foreground-400">
          <span>第 {story.episode} 集</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
          <span>{story.publishedAt}</span>
        </div>
        <h3 className="mt-2 line-clamp-1 text-base font-medium text-foreground-900 transition group-hover:text-primary-600">
          {story.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-500">{story.summary}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {story.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}